export const CAPACITY_DOMAINS = [
  { id: 'org-infra', name: 'Organizational Infrastructure' },
  { id: 'board-gov', name: 'Board Governance' },
  { id: 'programs', name: 'Programs and Services' },
  { id: 'partnerships', name: 'Community Partnerships' },
  { id: 'fund-dev', name: 'Resource & Fund Development' },
  { id: 'fiscal', name: 'Fiscal Management' },
  { id: 'tech', name: 'Data Systems & Technology' },
  { id: 'staff', name: 'Staff Management' },
  { id: 'eval', name: 'Evaluation' }
] as const;
